import {
  ActionIcon,
  Button,
  Divider,
  Drawer,
  Flex,
  useMantineTheme,
} from "@mantine/core";
import { useDisclosure, useMediaQuery } from "@mantine/hooks";
import { Add, HambergerMenu } from "iconsax-react";
import NotificationsNavbar from "../NotificationsNavbar";
import AccordionMenu from "./AccordionMenu";
import { LanguageSelect, Logo } from "../../components";
import { useAuth } from "../../context/auth";
import { client_selected } from "../../client";

const DrawerMenu = () => {
  const [opened, { open, close }] = useDisclosure(false);
  const theme = useMantineTheme();
  const { user } = useAuth();
  const isLargerThan600 = useMediaQuery("(min-width: 600px)");

  return (
    <>
      <ActionIcon size={44} variant="transparent" onClick={open} ml={-8}>
        <HambergerMenu color={theme.colors.basic[0]} size={28} />
      </ActionIcon>
      <Drawer.Root opened={opened} onClose={close}>
        <Drawer.Overlay />
        <Drawer.Content bg={theme.colors.primary[0]} w="100%" h="100%">
          <Flex direction="column" p="48px 0 56px">
            {/* Header */}
            <Flex p="0 24px 0" justify="space-between" align="center" mb="32px">
              <Flex gap="16px" align="center">
                <Button
                  leftIcon={
                    <Add
                      color={theme.colors.basic[0]}
                      size={32}
                      style={{ transform: "rotate(45deg)" }}
                    />
                  }
                  variant="transparentEspecial"
                  onClick={close}
                  h={32}
                  w={32}
                  styles={{
                    root: {
                      fontWeight: 400,
                    },
                    leftIcon: {
                      "@media (max-width: 1200px)": {
                        marginRight: "0",
                      },
                    },
                  }}
                />
                <Logo height={34} />
              </Flex>
              {!!user.name ? null : <NotificationsNavbar />}
            </Flex>

            {/* menu de navegação */}
            <AccordionMenu close={close} />
            <Divider m="26px 0" />
            {!!user.name || isLargerThan600 ? null : (
              <Flex p="0 24px 0" w="100%" justify="end" align="center">
                <LanguageSelect />
              </Flex>
            )}
          </Flex>
        </Drawer.Content>
      </Drawer.Root>
    </>
  );
};

export default DrawerMenu;
